export var FeatureCodePrefix;
(function (FeatureCodePrefix) {
    FeatureCodePrefix["PRE_INSTALLED"] = "pre-installed";
    FeatureCodePrefix["MISC_OPTION"] = "misc_option";
})(FeatureCodePrefix || (FeatureCodePrefix = {}));
//# sourceMappingURL=FeatureCodePrefix.js.map